import script from "./Main.vue?vue&type=script&lang=ts&setup=true"
export * from "./Main.vue?vue&type=script&lang=ts&setup=true"

import "./Main.vue?vue&type=style&index=0&id=48c05bca&scoped=true&lang=css"

import exportComponent from "E:\\code\\my\\bookmark.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48c05bca"]])

export default __exports__